export default [
    {
        path: '/paypal/transaction-rules',
        name: 'paypal_transaction_rule_overview',
        component: () => import('@src/paypal-transaction-rule/paypal-transaction-rule-overview.vue'),
        meta: {
            title: 'Paypal-Zuordnungsregeln',
            role: 'ROLE_PAYPAL_PAYMENT_TRANSACTION_RULE',
        },
    },
    {
        path: '/paypal/transaction-rule/create',
        name: 'paypal_transaction_rules_create',
        component: () => import('@src/paypal-transaction-rule/paypal-transaction-rule-create.vue'),
        meta: {
            title: 'Paypal-Regel anlegen',
            role: 'ROLE_PAYPAL_PAYMENT_TRANSACTION_RULE',
        },
    },
    {
        path: '/paypal/transaction-rule/edit/:id',
        name: 'paypal_transaction_rules_edit',
        component: () => import('@src/paypal-transaction-rule/paypal-transaction-rule-edit.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Paypal-Regel bearbeiten',
            role: 'ROLE_PAYPAL_PAYMENT_TRANSACTION_RULE',
        },
    },
];
